/// <amd-module name="Artifacts/Npm/commands/Promote" />

import { NpmActions } from "Artifacts/Npm/redux";
import { getPromoteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPromoteCommand = getPromoteCommandCreator(NpmActions.promote);
